import logo from 'themes/img/logo.svg';
import logo_test from 'themes/img/logo_test.svg';
import logo_staging from 'themes/img/logo_staging.svg';

export default function selectLogo() {
	if (process.env.NODE_ENV === 'awstesting' || process.env.NODE_ENV === 'awstesting-02') {
		return logo_test;
	}
	if (process.env.NODE_ENV === 'staging') {
		return logo_staging;
	}
	
	return logo;
}
